module.exports = __webpack_public_path__ + "static/media/nextArrow.547fbdb4.svg";